var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.49984V14.9998C2.5 16.8408 3.99238 18.3332 5.83333 18.3332H14.1667C16.0076 18.3332 17.5 16.8408 17.5 14.9998V7.49984M2.5 7.49984V6.24984C2.5 4.40889 3.99238 2.9165 5.83333 2.9165H14.1667C16.0076 2.9165 17.5 4.40889 17.5 6.24984V7.49984M2.5 7.49984H17.5M13.3333 1.6665V4.1665M6.66667 1.6665V4.1665",
    stroke: "#A5AFC0",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.3b3c28d986a1bc8970161130dcd5eb57.svg";
export { ForwardRef as ReactComponent };